<template>
   <div class="customer_container">
     <div class="customer_part01">
       <div>
         <p>微客服—助你开拓8亿高端用户</p>
         <button @click="showCustomerDialog=true">立即试用</button>
       </div>
     </div>
     <div class="live_part03">
       <div>
         <div class="live_question_left">
           <p>公众号和公众粉丝越来越多</p>
           <p>不知如何转化？</p>
           <p>客户资源大量流失，却手足无措？</p>
         </div>
         <div class="live_question_right customer_question_right">
           <h2><span>博商微客服平台<b></b></span></h2>
           <p>博商微客服平台完美对接，为商家微信公众号提供实时的消息收发功能，让您能更好地与微信用户进行沟通交流，更好的满足访客的需求，提高目标客户的用户体验，及时促进成交。
           </p>
         </div>
       </div>
     </div>
     <div class="customer_part04">
       <div class="customer_item01">
          <h1 class="customer_title">你想对你的客户了如指掌吗？</h1>
          <h3 class="customer_subtitle"><span>全面分析用户浏览的规律，快速了解访客心理，轻松掌握访客需求，轻松掌握客户来源<b></b></span></h3>
         <ul class="customer_list">
           <li><b></b>客服人员可全程监控网站用户数据，对访客来访提醒、来源跟踪、身份自动识别、活动轨迹监控等数据进行收集、整理、统计，提前了解客户意向，进行精准营销。</li>
           <li><b></b>消息预知功能，客服可提前知道访客心理，并提前最好对话准备。</li>
           <li><b></b>在后台可以过访客资料、跟踪服务记录、订单明细、和博商CRM结合等功能对不同的访客进行360度的了解。</li>
         </ul>
       </div>
       <div class="customer_item02">
         <h1 class="customer_title">100万渠道二维码，精准监控粉丝来源</h1>
         <h3 class="customer_subtitle"><span>为企业推广节省50%以上的广告费用<b></b></span></h3>
         <ul class="customer_list list_no_padding">
           <li>二维码被广泛应用于各个媒体渠道，但是你的粉丝来源于哪个渠道？</li>
           <li>哪个渠道来多少粉丝？这些渠道来的粉丝是否转化成为了顾客呢？</li>
           <li>渠道二维码功能将为帮助企业解决这个来源渠道统计问题，哪个渠道有效、哪个性价比高，一清二楚，让企业广告投放更精准更有效。</li>
         </ul>
       </div>
     </div>
     <div class="customer_part05">
       <div class="customer_machine_item01">
          <h1 class="customer_title">不眠不休的智能机器人</h1>
          <h3 class="customer_subtitle"><span>帮助企业实时提升成交率，为企业节约80%以上人力<b></b></span></h3>
         <ul class="customer_list">
           <li><b></b>通过博商云强大的智能引擎平台，根据问题精准分析语义，可解答90%以上的简单重复问题，机器人无法回答的问题，由人工确认后添加到知识库</li>
           <li><b></b>智能机器人能直接替代或辅助人工回答问题，并在工作中用深度学习技术自主学习优秀营销客服话术，更新知识库。</li>
           <li><b></b>机器人可同时接待万人以上的用户，从容应付业务高峰期，大幅度解放企业人力成本。</li>
           <li><b></b>根据聊天内容对访客数据统计及客服问题分析、新需求收集，深度挖掘数据信息，生成分析报表。</li>
         </ul>
       </div>
       <div class="customer_machine_item02">
         <h1 class="customer_title">客户信息无缝对接，服务更懂客户<b></b></h1>
         <ul class="customer_list list_no_padding customer_list_joint">
           <li>接口对接企业CRM，博商云帮企业明确微信公众号的服务对象，做更有针对性的服务，营销。一键转意向客户，跨部门协调，客户服务情况清晰明了，再也不用跑断腿。</li></li>
         </ul>
       </div>
     </div>
     <div class="customer_part06">
       <div class="customer_machine_item03">
         <h1 class="customer_title">强大的客户二次挖掘功能</h1>
         <h3 class="customer_subtitle"><span>每天多挖30%的客户<b></b></span></h3>
         <ul class="customer_list">
           <li><b></b>通过使用微客服平台，我们可以对公众粉丝进行再次挖掘，只要客户不取消关 注，就可以在48小时内，对客户进行多次沟通!</li>
           <li><b></b>据我们客户反馈，微信客户的二次开发转化率，可以达到30%!如果一个企业每天有100个微信客户可以二次开发。那么就可以再成交30%个客户，平均每个客户成交成本是100元;那么一年就可以为企业节约广告费:30x100x365=109.5万元这个效果是在Pc上做网络营销无去达到。
           </li>
         </ul>
       </div>
       <div class="customer_machine_item04">
         <h1 class="customer_title">对话功能强大</h1>
         <h3 class="customer_subtitle"><span>同时接入多个微信公众统一管理<b></b></span></h3>
         <ul class="customer_list list_no_padding">
           <li>客服可随时和顾客说话，访问即开通，客服可实时看到顾客所输入的内容同时接入多个微信公众统一管理。多个客服同时在线，可绑定多个公众号一个客服同时接待多个粉丝咨询，同时接待数量无上限，聊天记录长期保存
           </li>
           </li>
         </ul>
       </div>
     </div>
     <div class="live_part10 customer_part03">
       <div>
         <div><span>服务保障</span></div>
         <div><img src="../assets/images/server_line.png" alt=""></div>
         <ul>
           <li><strong>品质保障</strong><span>博商管理科学研究院旗下公司首推应用平台</span></li>
           <li><strong>安全防护</strong><span>拥有国内高级别的安全防护与数据监控措施</span></li>
           <li><strong>多元化服务</strong><span>7*12小时服务响应，专属客户经理，专人运维保障</span></li>
           <li><strong>全面支持</strong><span>多元化集成，同时与微信、APP、CRM无缝对接</span></li>
           <li><strong>自定义功能强大</strong><span>满足不同业态定制化需求</span></li>
         </ul>
       </div>
     </div>
     <my-dialog :show-dialog.sync="showCustomerDialog"></my-dialog>
   </div>
</template>

<script>
  import myDialog from '../components/my-dialog'
    export default {
        name: 'customerService',
        data:function(){
          return {
            showCustomerDialog:false
          }
        },
      components:{myDialog}
    }
</script>



// WEBPACK FOOTER //
// src/components/customerService.vue